import Vue from 'vue'
import $ from 'jquery'
import axios from "axios";

const BaseApi = {
    createCompany: function (reqData, fnOk, fnFailed) {
        Vue.prototype.$api.showIdle()
        var cmp = this
        var url = Vue.prototype.$config.HOST + '/v1/companies?time=' + new Date().getTime()
        $.post(url, reqData, function (data) {
            Vue.prototype.$api.hideIdle()
            fnOk(data)
        }).catch(function (error, a, b, c) {
            if (fnFailed) {
                Vue.prototype.$api.hideIdle()
                fnFailed(error)
            } else {
                cmp.onGetError(error, a, b, c, fnFailed)
            }
        })
    },
    exportToCSV: function (data, fnOk, fnFailed) {
        Vue.prototype.$api.showIdle()
        var cmp = this
        var url = Vue.prototype.$config.HOST + '/v1/companies/stats?time=' + new Date().getTime()
        // reqData.type = type
        let xhr = new XMLHttpRequest();
        xhr.open('POST', url);
        xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
        xhr.responseType = 'blob';

        xhr.send(JSON.stringify(data));

        xhr.onload = function (e) {

            if (this.status == 200) {
                fnOk(e)
                Vue.prototype.$api.hideIdle()
                // Create a new Blob object using the response data of the onload object
                var blob = new Blob([this.response], {type: 'text/csv'});
                //Create a link element, hide it, direct it towards the blob, and then 'click' it programatically
                let a = document.createElement("a");
                a.style = "display: none";
                document.body.appendChild(a);
                //Create a DOMString representing the blob and point the link element towards it
                let url = window.URL.createObjectURL(blob);
                a.href = url;
                a.download = 'export.csv';
                //programatically click the link to trigger the download
                a.click();
                //release the reference to the file by revoking the Object URL
                window.URL.revokeObjectURL(url);
            } else {
                cmp.onGetError(e, fnFailed)
            }
        };
    },
    deleteCompany: function (companyId, fnOk, fnFailed) {
        Vue.prototype.$api.showIdle()
        var cmp = this
        $.get(Vue.prototype.$config.HOST + '/v1/companies/' + companyId + '/delete?time=' + new Date().getTime() + '&token=' + Vue.prototype.$api.getCredentials().authToken, function (data) {
            Vue.prototype.$api.hideIdle()
            if (fnOk) fnOk(data)
        }).catch(function (error, a, b, c) {
            if (fnFailed) {
                Vue.prototype.$api.hideIdle()
                fnFailed(error)
            } else {
                cmp.onGetError(error, a, b, c, fnFailed)
            }
        })
    },
    loadCompanies: function (reqData, fnOk, fnFailed) {
        Vue.prototype.$api.showIdle()
        var cmp = this
        var url = Vue.prototype.$config.HOST + '/v1/companies/list?time=' + new Date().getTime()
        $.post(url, reqData, function (data) {
            Vue.prototype.$api.hideIdle()
            fnOk(data)
        }).catch(function (error, a, b, c) {
            if (fnFailed) {
                Vue.prototype.$api.hideIdle()
                fnFailed(error)
            } else {
                cmp.onGetError(error, a, b, c, fnFailed)
            }
        })
    },
    loadCompany: function (companyId, fnOk, fnFailed) {
        Vue.prototype.$api.showIdle()
        var cmp = this
        var url = Vue.prototype.$config.HOST + '/v1/companies/' + companyId
        axios({
            method: 'get',
            url: url,
            params: {
                token: Vue.prototype.$api.getCredentials().authToken,
                time: new Date().getTime()
            },
            responseType: 'json'
        })
            .then(function (response) {
                Vue.prototype.$api.hideIdle()
                console.log('companyData', companyId)
                if (fnOk) {
                    fnOk(response.data)
                }
            })
            .catch(error => {
                console.log(error.response)
                Vue.prototype.$api.hideIdle()
                if (fnFailed) {
                    fnFailed(error.response)
                } else {
                    cmp.onGetError(error)
                }
            })
    },
    updateCompany: function (companyId, reqData, fnOk, fnFailed) {
        Vue.prototype.$api.showIdle()
        var cmp = this
        var url = Vue.prototype.$config.HOST + '/v1/companies/' + companyId + '?time=' + new Date().getTime()

        $.post(url, reqData, function (data) {
            Vue.prototype.$api.hideIdle()
            fnOk(data)
        }).catch(function (error, a, b, c) {
            if (fnFailed) {
                Vue.prototype.$api.hideIdle()
                fnFailed(error)
            } else {
                cmp.onGetError(error, a, b, c, fnFailed)
            }
        })
    }
}


export default BaseApi
